import React, { createContext, useContext, useState } from 'react';
import ErrorModal from '../componets/ErrorModal';

const ErrorContext = createContext();

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [showErrorModal, setShowErrorModal] = useState(false);

  const showError = () => {
    setShowErrorModal(true);
  };

  const hideError = () => {
    setShowErrorModal(false);
  };

  return (
    <ErrorContext.Provider value={{ showError, hideError }}>
      {children}
      <ErrorModal isOpen={showErrorModal} onClose={hideError} />
    </ErrorContext.Provider>
  );
};